module.exports = __webpack_public_path__ + "static/jump-into-stem-3289941650a4da448bdc9e006ae4c6f4.png";